var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"body-row"}},[_c('Sidebar'),_vm._v(" "),_c('div',{class:{'col-10 col-sm-10 col-md-11 col-lg-11':_vm.collapsemenu===true,'col-9 col-sm-9 col-md-10 col-lg-10':_vm.collapsemenu===false},attrs:{"id":"panel-principal"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81faf940","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content.vue
// module id = null
// module chunks = 